<button id="selectedItem" (click)="toggleOpen()">
  {{ selected && selected.label | translate  }}
</button>
<ul [class.open]="open">
  <li *ngFor="let item of items"
      [class.selected]="isItemSelected(item)"
      [class.disabled]="item.disabled"
      (click)="selectItem(item)">
    {{ item.label | translate }}
  </li>
</ul>
